import { render } from "./GridContainer.vue?vue&type=template&id=2a6d5e8e"
const script = {}

import "./GridContainer.vue?vue&type=style&index=0&id=2a6d5e8e&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__